import "core-js/stable";
import "regenerator-runtime/runtime";

import { gsap } from "gsap";

import { Scroll } from './_app/cuchillo/scroll/Scroll';

import './_app/cuchillo/scroll/insiders/VSticky';
import './_app/cuchillo/scroll/insiders/VDisplace';
import './_app/cuchillo/scroll/insiders/VScale';
import './_app/cuchillo/scroll/insiders/VScaleZero';
import './_app/cuchillo/scroll/insiders/VInsider';

import './scroll/ScrollItem__BlockDefault';
import './scroll/ScrollItem__StepText';
import './scroll/ScrollItem__StepItems';
import './scroll/ScrollItem__StepPercentage';
import './scroll/ScrollItem__Form';
import './scroll/ScrollItem__BlockWysiwyg';
import './scroll/ScrollItem__BlockImage';
import './scroll/ScrollItem__BlockSliderHorizontalScroll';
import './scroll/ScrollItem__BlockSliderDefault';
import './scroll/ScrollItem__BlockSliderCircular';
import './scroll/ScrollItem__BlockAccordions';
import './scroll/ScrollItem__ProjectList';
import './scroll/ScrollItem__BlockPlayerVideo';
import './scroll/ScrollItem__BlockTextHighlight';
import './scroll/ScrollItem__BlockMedia';
import './scroll/ScrollItem__BlockFaqs';
import './scroll/ScrollItem__BlockHighlightProjects';
import './scroll/ScrollItem__BlockLatestNews';
import './scroll/ScrollItem__WidgetProjects';
import './scroll/ScrollItem__WidgetContact';
import './scroll/ScrollItem__BlockText';
import './scroll/ScrollItem__BlockGallery';
import './scroll/ScrollItem__BillboardSea';
import './scroll/ScrollItem__BlockJunk';
import './scroll/ScrollItem__BlockGodrays';
import './scroll/ScrollItem__Footer';
import './scroll/ScrollItem__BlockJunkIntro';
import './scroll/ScrollItem__Legales';
import './scroll/ScrollItem__BlockCta';
import './scroll/ScrollItem__BlockTextCreature';
import './scroll/ScrollItem__BlockReviews';
import './scroll/ScrollItem__BlockMockup';
import './scroll/ScrollItem__BillboardLogo';
import './scroll/ScrollItem__BlockLogos';
import './scroll/ScrollItem__WidgetTeam';
import './scroll/ScrollItem__WidgetJobs';
import './scroll/ScrollItem__BlockNews';
import './scroll/ScrollItem__BillboardLogoCopy';
import './scroll/ScrollItem__BlockLetter';
import './scroll/ScrollItem__BlockStep';
import './scroll/ScrollItem__BlockParticlesFake';
import './scroll/ScrollItem__BlockLanding';
import './scroll/ScrollItem__BlockCreature';
import './scroll/ScrollItem__ReportCover';
import './scroll/ScrollItem__ReportText';
import './scroll/ScrollItem__ReportQuote';
import './scroll/ScrollItem__ReportTakeaways';
import './scroll/ScrollItem__ReportToc';
import './scroll/ScrollItem__ReportChapter';
import './scroll/ScrollItem__ReportStat';
import './scroll/ScrollItem__ReportCase';
import './scroll/ScrollItem__ReportSteps';
import './scroll/ScrollItem__ReportFaq';
import './scroll/ScrollItem__ReportCta';
import './scroll/ScrollItem__ReportCaseLarge';
import './scroll/ScrollItem__ReportIndexItem';
import './scroll/ScrollItem__ReportStatComplex';
import './scroll/ScrollItem__WidgetReports';
import './scroll/ScrollItem__ProductTabs';
import './scroll/ScrollItem__ProductCards';
import './scroll/ScrollItem__ProductQuote';
import './scroll/ScrollItem__ProductCta';
import './scroll/ScrollItem__ClientLogos';
import './scroll/ScrollItem__BlockTimeline';
import './scroll/ScrollItem__BlockCards';
import './scroll/ScrollItem__BlockGalleryVortex';
import './scroll/ScrollItem__ProductBillboard';
import './scroll/ScrollItem__ProductCases';
import './scroll/ScrollItem__CaseText';
import './scroll/ScrollItem__CaseQuote';
import './scroll/ScrollItem__CaseCards';
import './scroll/ScrollItem__CaseMedia';

import { Accessibility } from './_app/cuchillo/core/Accessibility';
import { Basics, isDebug } from './_app/cuchillo/core/Basics';
import EventDispatcher from './_app/cuchillo/core/EventDispatcher';
import { Interaction } from './_app/cuchillo/core/Interaction';
import { Metrics } from './_app/cuchillo/core/Metrics';
import { Statics } from './_app/cuchillo/utils/Statics';
import Keyboard from './_app/cuchillo/core/Keyboard';

import LoaderController from './_app/cuchillo/loaders/LoaderController';
import PagesLoader from './_app/cuchillo/loaders/PagesLoader';

import { ControllerPage } from './_app/cuchillo/pages/ControllerPage';
import Page from './_app/cuchillo/pages/Page';
import './pages/Default';
import './pages/Legal';
import './pages/Home';
import './pages/About';
import './pages/Report';
import './pages/Reports';
import './pages/Product';
import './pages/Case';

import BG from './_app/cuchillo/layout/Background';
import InterfaceCanvas from './_app/cuchillo/layout/InterfaceCanvas';
import Header from './layout/Header';
import Loading from './layout/Loading';
import Wrap from './layout/Wrap';

import { ControllerWindow } from './_app/cuchillo/windows/ControllerWindow';
import './_app/cuchillo/windows/Window';
import './_app/cuchillo/windows/WinIframe';
import Preloader from "./layout/Preloader";
import Sidemenu from "./layout/Sidemenu";
import Language from "./_app/cuchillo/utils/Language";
import CMP from "./windows/Cmp";
import WebGLSketch from "./_app/cuchillo/3D/WebGLSketch";
import Scene from "./3D/Scene";
import Guides from './_app/cuchillo/utils/Guides';

export default class Main {
  static stats;

  static init() {
    gsap.ticker.fps(60);

    // Evita que el navegador restauri el scroll al refrescar (desquadra els tops dels scroll-item
    // respecte Scroll.y / Lenis; el init ja fa scrollTo(0) de forma controlada).
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    // DEV: desregistra qualsevol service worker antic i buida les seves caches (evita servir
    // bundles/JS obsolets — el `service-worker.js` cacheja i persisteix entre sessions).
    if (isDebug && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
      if (self.caches) caches.keys().then((ks) => ks.forEach((k) => caches.delete(k)));
    }

    Basics.id = "GF_v002"; // ID para cookies
    Language.init();

    Header.init();
    Sidemenu.init();

    WebGLSketch.init();
    Scene.init(); // escena 3D GENÈRICA: s'inicia UN cop i es veu SEMPRE (el compositor pinta
    //                   el canvas cada frame). El progress/split el mou qualsevol membre (BillboardSea).

    Metrics.init(() => Main.resize()); // Tamaños y resize
    Keyboard.enable(); // ESC para cerrar ventana
    Accessibility.init(); // Utils accesibilidad
    Statics.init(); // Si estamos en debug pinta un FPS counter
    Interaction.init({ ajax: true }) // Posiciones del cursor (Movimiento, click...), Acciones links, drag...
    ControllerWindow.init(); // Control ventanas

    BG.init(CMS_COLORS); // Control de paletas y color de fondo de pantallas. Automatico si añadimos un data-palette='loquesea' en el div con data-page
    InterfaceCanvas.init(); // Canvas de interface, se usa con Cursor
    CMP.init(); // Checkea y saca el aviso de cookies
    //Cursor.init();

    Guides.init();
    Guides.add({
      cols: 12,
      enabled: false,
      padding: Metrics.parseSize("10fpx"),
      gap: Metrics.parseSize("10fpx"),
      color: "#FF0000"
    });

    LoaderController.add(new PagesLoader()); // Carga/Precarga de paginas HTML
    //LoaderController.add(new MediaLoader()); // Carga/Precarga de imgs
    LoaderController.update = progress => Preloader.update(progress);
    LoaderController.onComplete = () => Main.setup();

    //LOOP
    gsap.ticker.lagSmoothing(0);
    if (isDebug) {
      gsap.ticker.add((time) => { Main.loopDebug(time); });
    } else {
      //this.setWorker();
      this.doCuchilloInfo();
      gsap.ticker.add((time) => { Main.loop(time); });
    }

    Preloader.init();
    LoaderController.init();
  }

  static setup() {

    // Sidemenu.mode = "normal";
    // Sidemenu.showButton();

    this.setupEvents();
    // INIT PAGE
    ControllerPage.init(Wrap.mainholder);
  }

  static setupEvents() {
    EventDispatcher.addEventListener(Page.ON_SHOW, () => {
      //Cursor.start();
      Loading.stop();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE, () => {
      //Cursor.hide();
      Sidemenu.hide();
    });
    EventDispatcher.addEventListener(Page.ON_HIDE_END, () => {
      Loading.start();
    });

    /*EventDispatcher.addEventListener(Win.ON_HIDE, () => { Scroll.setEnabled(true); });
    EventDispatcher.addEventListener(Win.ON_SHOW, () => { Scroll.setEnabled(false); });
    EventDispatcher.addEventListener(Sidemenu.ON_HIDE, () => { Scroll.setEnabled(true); });*/
    EventDispatcher.addEventListener(Sidemenu.ON_SHOW, () => {
      //Scroll.setEnabled(false);
      ControllerWindow.hideAll();
    });
  }

  static resize() {
    Header.resize();
    Sidemenu.resize();
    InterfaceCanvas.resize();
    BG.resize();
    ControllerPage.resize();
    WebGLSketch.resize();
    Guides.resize();
    Scroll.resize();
    //Cursor.resize();

    // NO forçar height de #Main en touch: amb Lenis (scroll natiu) deixa el document
    // a 100vh i no es pot arribar al footer (quedava tallat a baix).
  }

  static loop(time) {
    Scroll.loop(time);

    InterfaceCanvas.loop();
    ControllerPage.loop();
    BG.loop();
    Header.loop();
    Sidemenu.loop();
    InterfaceCanvas.loop();
    Scene.loop(); // mar + double render (sempre actiu; no-op si no s'ha fet start)
    WebGLSketch.loop();
    //Cursor.loop();
  }

  static loopDebug(time) {
    Statics.begin();
    this.loop(time);
    Statics.end();
  }

  static doCuchilloInfo() {
    // Constantes
    const TIMESTAMP = 'July 29th, 2026';
    const LOCATION = 'Bilbao';
    const COMPANY_DESC = 'Cuchillo© is a creative team specialized\nin building new perspectives and bold digital\nconcepts for brands to be timeless.';

    // Enlaces sociales
    const SOCIAL_LINKS = [
      'http://somoscuchillo.com',
      'https://www.instagram.com/_cuchillo',
      'https://bsky.app/profile/cuchillo.studio',
      'https://bsky.app/profile/mrcorrales.com',
    ];

    // Logo SVG
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 80">
        <path fill="black" d="M71.8 65.1V54.4c0-4.7-3.9-2.5-4.3-4.7-.1-.3-.1-.6-.1-.9V26.5l8 6.7 6.9-5.8L72 18.8 59 31.7v17.5c.2 2.1 4.6 1 4.4 5.2v15.3L74.6 79l10.8-10.6-8.2 1.2-5.4-4.5zm-58.9 0V54.4c0-4.7-3.9-2.5-4.3-4.7-.1-.3-.1-.6-.1-.9V26.5l8 6.7 6.9-5.8L13 18.8 0 31.7v17.5c.2 2.1 4.6 1 4.4 5.2v15.3L15.6 79l10.8-10.6-8.2 1.2-5.3-4.5zM132 54.4c.1-2.9-4.5-2.3-4.4-5.2V23.7l-5.8-4.9-7.6 7.5 4.9 4.1s.1 4 .1 17.9v.9c0 2.9 4.5 2.4 4.4 5.4l.1 19.4 5.8 5 7.2-7.2-4.8-4.1V54.4zm17.3.2c.2-3.8-4.4-2.9-4.4-5.6V1l-8.5 8.4v39.9c.1 2.4 4.4 1.4 4.4 5v18.6L149 79l6.3-6.3-6-5V54.6zM191.5 72l-6.9-5.7V54.7c0-2.8-3.9-2.5-3.9-5.1v-24l6.9 5.8v17.4c0 3.2 3.9 1.7 3.9 5.8V72zm4.6-22.6V26.9l-9.8-8.1-6.4 6.4s-6.7 6.7-7.5 7.4l-.1.1v16.2c0 2.9 3.8 2.6 3.9 5.7v16.2L186 79l14-14V54.6c0-4.1-3.7-2.7-3.9-5.2m-28.6 5.2c.1-3.4-4.4-2.8-4.4-4.7V.9l-8.5 8.5v39.9c.1 3.1 4.4.8 4.4 5.4V73l8.1 6.1 6.3-6.3-5.9-5V54.6zm-58-4.9v-.2-21l-9.1-6.2-6.2 6.2 6.9 5.8v14.9c0 .3 0 .6.1 1 0 2.6 4.3 1.4 4.4 4.5v24.6l8.5-8.5v-16c0-4.6-4.6-2.9-4.6-5.1m18.2-40.2l-5.8-5.9-6.1 5.9 6 5.9 5.9-5.9zm-42 .1v39.8c0 2.9 4.4 2.2 4.4 5.2v24.5l8.5-8.4V54.6c0-2.9-4.4-2.2-4.4-5V1.2l-8.5 8.4zM51 50c-.1-.3-.1-.6-.1-.9V18.8l-8.5 8.5s0 22.3.1 22.6c0 2.9 4.3 1.1 4.3 4.5V72L40 66.4v-12c0-3.2-4.2-2.2-4.4-5.2V18.8l-8.5 8.4v21.3c0 .3 0 .6.1.9.4 2.2 4.4 2.2 4.4 4.9v16.6l9.9 8.2 13.8-13.8v-11c0-3.4-3.7-2.5-4.3-4.3"></path>
    </svg>`;
    const svgUrl = `data:image/svg+xml;base64,${btoa(svg)}`;

    // Imprimir información en consola
    console.log(`%cProudly made in ${LOCATION} - ${TIMESTAMP}`, 'font-size:8px;');
    console.log('%c ', `
        font-size: 0; 
        padding: 60px 150px; 
        background: url(${svgUrl}) no-repeat center; 
        background-size: contain;
        margin-bottom: 10px;
    `);

    // Imprimir descripción
    console.log(`%c${COMPANY_DESC}`, '');

    // Imprimir enlaces sociales
    SOCIAL_LINKS.forEach((link, index) => {
      console.log(`${String.fromCharCode(9312 + index)} ${link}`);
    });
  }

  static setWorker() {
    if ('serviceWorker' in navigator && !isDebug) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function () { });
    }
  }
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  Main.init();
} else {
  document.addEventListener('DOMContentLoaded', Main.init);
}
